import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Partner } from "@customTypes/partner";

import { clinicQKeys } from "./queryKeys";


interface GetPartnersProps {
  managementView?: boolean;
  isActive?: boolean;
  isOrganization?: boolean;
  isEnabled?: boolean;
}

export const useGetPartners = ({
  managementView = false,
  isActive,
  isOrganization,
  isEnabled = true,
}: GetPartnersProps = {}) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: [...clinicQKeys.partnersWithFilters({ isActive, isOrganization }), { managementView }],
    queryFn: async () => {
      const { data } = await api.get<Partner[]>(managementView ? "partners/" : "partners/options", {
        params: {
          is_active: isActive,
          is_organization: isOrganization,
        },
      });

      return data;
    },
    enabled: isEnabled,
    onError: (res: any) => {
      console.error("[From Get Partners]", res);
      handleErrors(res, "query");
    },
  });
};
